export const INLINE_BLOCK_TAG = 'inline-block';

// Emitted directly by the agent's create_number_block tool, wrapping a
// numeric value that is already part of the response text.
export const PULSE_NUMBER_TAG = 'pulse-num';

const PULSE_NUMBER_MARKER_REGEX = /<pulse-num\b[^>]*>([\s\S]*?)<\/pulse-num>/g;

// For clipboard/export paths: keeps the value text, drops the markup.
export const stripPulseNumberMarkers = (markdown: string): string =>
  markdown.replace(PULSE_NUMBER_MARKER_REGEX, '$1');

const BLOCK_MARKER_REGEX = /<<BLOCK:([^>]+)>>/g;

const INLINE_CODE_SPAN_REGEX = /(`+)[\s\S]*?\1/g;

const escapeAttribute = (value: string): string =>
  value.replace(/&/g, '&amp;').replace(/"/g, '&quot;');

// The close tag goes on its own line so that a marker occupying a whole
// markdown paragraph is parsed as an HTML block (CommonMark type 7) instead of
// being wrapped in a <p>, which would nest the rendered block inside it.
const convertSegment = (markdown: string): string =>
  markdown.replace(
    BLOCK_MARKER_REGEX,
    (_, name: string) =>
      `<${INLINE_BLOCK_TAG} data-name="${escapeAttribute(name.trim())}">\n</${INLINE_BLOCK_TAG}>`,
  );

// Markers inside inline code spans (`...`) are left as literal text; fenced
// code blocks are already protected upstream by protectCodeBlocks.
export const convertBlockMarkers = (markdown: string): string => {
  let result = '';
  let lastIndex = 0;
  INLINE_CODE_SPAN_REGEX.lastIndex = 0;
  for (const match of markdown.matchAll(INLINE_CODE_SPAN_REGEX)) {
    const matchIndex = match.index ?? 0;
    result += convertSegment(markdown.slice(lastIndex, matchIndex));
    result += match[0];
    lastIndex = matchIndex + match[0].length;
  }
  result += convertSegment(markdown.slice(lastIndex));
  return result;
};
